import {
  body1,
  body2,
  button,
  caption,
  fontMedium,
  fontRegular,
  fontSemiBold,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  overline,
  subheading1,
  subheading2
} from 'assets/fonts';

export * from 'assets/fonts';

export const typography = (palette: any) => ({
  fontSize: 14,
  fontFamily: fontRegular,
  h1: { ...h1 },
  h2: { ...h2 },
  h3: { ...h3 },
  h4: { ...h4 },
  h5: { ...h5 },
  h6: { ...h6 },
  subtitle1: { ...subheading1 },
  subtitle2: { ...subheading2 },
  body1: {
    ...body1,
    color: palette.text.secondary,
  },
  body2: {
    ...body2,
    color: palette.text.secondary,
  },
  caption: {
    ...caption,
    color: palette.secondary.main,
  },
  button: {
    ...button,
    fontFamily: fontMedium,
    textTransform: 'none',
  },
  overline: {
    ...overline,
    fontFamily: fontSemiBold,
    color: palette.secondary.main,
  },
  listItem: {
    ...body2,
    fontWeight: 600,
    color: palette.primary.main
  }
});
